import type { User } from '@openapi'

export type CanvasTypographyPresetId = 'h_1' | 'h_2' | 'h_3' | 'big_text' | 'normal_text' | 'small_text'

export type CanvasTypographyPreset = {
  id: CanvasTypographyPresetId
  color: string
  font_family: string
  font_size: string
  font_weight: '400' | '700'
  letter_spacing: string
  line_height: string
  text_transform: 'capitalize' | 'lowercase' | 'none' | 'uppercase'
}

export enum CanvasThemeStatus {
  READY = 'ready',
  DRAFT = 'draft',
}

export interface CanvasThemeAsset {
  id: string
  name: string
  url: string
}

export interface CanvasThemeSettings {
  component_spacing: number
  background_color: string
  palette: string[]
  assets?: CanvasThemeAsset[]
}

export interface CanvasThemeRetrieve {
  id: string
  instance_id: string
  status: CanvasThemeStatus
  is_default: boolean
  name: string
  created_at: string
  modified_at: string
  owned_by: User
  created_by: User
  modified_by?: User
  logo?: CanvasThemeAsset
  assets?: CanvasThemeAsset[]
  settings: CanvasThemeSettings
  typography: Record<string, CanvasTypographyPreset>
  used_in_canvases_count?: number
}

export interface CanvasThemeFormData {
  settings: {
    name: string
    status: CanvasThemeStatus
    componentSpacing: number
  }
  colors: {
    background_color: string
    palette: string[]
  }
  typography: Record<string, CanvasTypographyPreset>
  assets: {
    logo?: CanvasThemeAsset
    images: CanvasThemeAsset[]
  }
}
